var _circle, _rect, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _path2, _path3, _path4, _path5, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyRelatedItems(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 157,
    viewBox: "0 0 216 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 80.5,
    r: 75.5,
    fill: "#F1F3F9",
    stroke: "#DADEEB",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 30,
    width: 145,
    height: 99,
    rx: 2,
    fill: "white",
    stroke: "#DADEEB",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 32C42.5 30.8954 43.3954 30 44.5 30H185.5C186.605 30 187.5 30.8954 187.5 32V41H42.5V32Z",
    fill: "#F1F3F9",
    stroke: "#DADEEB",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 71,
    r: 8,
    fill: "#9FA8BA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 35.5,
    r: 1.5,
    fill: "#DADEEB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 35.5,
    r: 1.5,
    fill: "#DADEEB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 35.5,
    r: 1.5,
    fill: "#DADEEB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 71,
    r: 8,
    fill: "#9FA8BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 94.0796C110 88.5 121.5 88.9999 130.5 94.0796",
    stroke: "#9FA8BA",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183 19V5",
    stroke: "#9FA8BA",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.5 35L212.5 35",
    stroke: "#9FA8BA",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 21.8995L205.399 12",
    stroke: "#9FA8BA",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 67.5,
    r: 2.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 67.5,
    r: 2.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 70.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 69.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 73,
    r: 2,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 73,
    r: 2,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 4.5,
    r: 4.5,
    fill: "#F1F3F8"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 92,
    r: 10,
    fill: "#F1F3F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRelatedItems);
export default __webpack_public_path__ + "static/media/empty-related-items.12f5e651f5e1351e45974f4da8939b21.svg";
export { ForwardRef as ReactComponent };